import ContextsTableDescriptionCell from "./DescriptionCell";
import ContextsTableSpaceCell from "./SpaceCell";
import ContextTableCreatedAtCell from "./CreatedAtCell";
import ContextsTableLabelsCell from "./LabelsCell";
import ContextsTableNameLinkCell from "./NameCell";
import { CONTEXTS_COLUMN_ID } from "../constants";
import ContextsTableRowActionsCell from "./RowActionsCell";

export const CONTEXTS_TABLE_CELLS = {
  [CONTEXTS_COLUMN_ID.DESCRIPTION]: ContextsTableDescriptionCell,
  [CONTEXTS_COLUMN_ID.NAME]: ContextsTableNameLinkCell,
  [CONTEXTS_COLUMN_ID.SPACE]: ContextsTableSpaceCell,
  [CONTEXTS_COLUMN_ID.CREATED_AT]: ContextTableCreatedAtCell,
  [CONTEXTS_COLUMN_ID.LABELS]: ContextsTableLabelsCell,
  [CONTEXTS_COLUMN_ID.DROPDOWN]: ContextsTableRowActionsCell,
};
